import {Injectable} from '@angular/core';
import {Socket} from 'ngx-socket-io';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class ChatService {
    backgroundMode = false;

    showEmojiPanelInChat = new BehaviorSubject(false);

    constructor(private socket: Socket) {
        this.showEmojiPanelInChat.next(false);
    }

    listen(conversationId: number): Observable<any> {
        this.socket.emit('joinConversation', {conversation_id: conversationId});
        return this.socket.fromEvent('chatResponse').pipe(map((res: any) => {
            return JSON.parse(res['data']);
        }));
    }

    leave(conversationId: number) {
        this.socket.emit('leaveConversation', {conversation_id: conversationId});
    }

    sendSimpleMessage(from: string) {
        this.socket.emit('chatEvent', {
            data: JSON.stringify({
                from,
            }), 
            conversation_id: 0 // 意味不明！これ何！？
        });
    }

    sendMessage(data: {
        from: string,
        userId: number | null,
        projectId: number,
        conversationId: number,
        messageId?: number,
        to?: number[],
        isProjectUnread?: boolean,
        isDirectChatUnread?: boolean}
        ) {
        this.socket.emit('chatEvent', {
            data: JSON.stringify(data),
            conversation_id: 0 // 意味不明！これ何！？
        });
    }

    ping() {
        this.socket.emit('ping', {
            ping: "pong"
        });
    }
}
